<section class="mt-5 text-center d-flex flex-column align-items-center">
  <div class="h4">Loading Payment Data</div>
  <div class="spinner-border text-primary mt-4" role="status">
    <span class="visually-hidden">loading...</span>
  </div>
</section>
